export default __webpack_public_path__ + "static/media/USD.50492366.svg";